<script setup>
import { ref } from 'vue';
import RevisionModal from "@/components/approval-center/modals/RevisionModal.vue";
import LoadingModal from "@/components/approval-center/modals/LoadingModal.vue";
import useApprovalFlow from "@/composables/approval-center/useApprovalFlow";

const feedbackValue = defineModel('feedback', {
  type: String,
  required: true,
});

defineProps({
  loading: {
    type: Boolean,
    required: true
  },
});

const emit = defineEmits(['close', 'continue', 'confirm']);
const showLoadingModal = ref(false);

const {revisionErrors: errors} = useApprovalFlow();

const handleConfirm = () => {
  showLoadingModal.value = true;
  emit('confirm');
};

const handleContinue = () => {
  showLoadingModal.value = false;
  emit('continue');
}
</script>

<template>
  <RevisionModal
    v-if="!showLoadingModal || errors"
    v-model="feedbackValue"
    @close="emit('close')"
    @confirm="handleConfirm"
  />

  <LoadingModal
    v-else
    :loading="loading"
    @continue="handleContinue"
  />
</template>
